import type { DetrixSession } from '../types';

export function getSessionApiBase(): string {
  return (import.meta.env.VITE_SESSION_API_BASE ?? '').trim().replace(/\/$/, '');
}

export async function copyShareLinkForSession(
  session: DetrixSession,
): Promise<{ ok: true } | { ok: false; error: string }> {
  const apiBase = getSessionApiBase();
  if (!apiBase) {
    return { ok: false, error: 'VITE_SESSION_API_BASE is not set' };
  }
  try {
    const res = await fetch(`${apiBase}/sessions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(session),
    });
    const data = (await res.json()) as { url?: string; error?: string };
    if (!res.ok) return { ok: false, error: data.error ?? `HTTP ${res.status}` };
    if (!data.url) return { ok: false, error: 'Missing url in response' };
    await navigator.clipboard.writeText(data.url);
    return { ok: true };
  } catch (e) {
    return { ok: false, error: e instanceof Error ? e.message : String(e) };
  }
}
